import React, { useCallback, useMemo } from "react";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import { connect } from "react-redux";
import JamezzTableV2, { useReloadState } from "../../components/JamezzTable/V2/JamezzTableV2";
import useJTFilter from "../../components/JamezzTable/V2/useJTFilter";
import { useDialog } from "../../licensing/utils/DialogProvider";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { Checkbox, GridLegacy, IconButton, TableCell, Tooltip } from "@mui/material";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import MainNavbar from "../../components/Navbars/MainNavbar";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import Button from "../../components/CustomButtons/Button";
import { Add, Delete, FreeBreakfast } from "@mui/icons-material";
import AreYouSureDialog from "../../components/Dialogs/AreYouSureDialog";
import { _post } from "../../http";

const endPoint = "core/scheduledTasks";

function ScheduledTasks(props) {
  const { reloadState, updateReloadState } = useReloadState();
  const [textField, searchFilter] = useJTFilter("name");

  const [openDialog] = useDialog();
  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "name",
        label: <TranslationWrapper tDefault={"Scheduled task name"} tKey={"scheduledTasks.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "active",
        label: <TranslationWrapper tDefault={"Active"} tKey={"scheduledTasks.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row, isEditable) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>{row.task_name}</TableCell>
        <TableCell>
          {/*<FormElement*/}
          {/*  name={"active"}*/}
          {/*  row={row}*/}
          {/*  endPoint={endPoint}*/}
          {/*  fieldProps={(props) => ({ checked: !!props.value })}*/}
          {/*>*/}
          {/*    <Checkbox color={"primary"} />*/}
          {/*</FormElement>*/}
          <Checkbox checked={row.active} color={"primary"} disabled />
        </TableCell>
      </>
    );
  }, []);

  const renderSelectionActions = useCallback((selected) => {
    return (
      <Tooltip title={<TranslationWrapper tKey={"Delete"} />}>
        <IconButton
          onClick={() => {
            openDialog({
              children: (
                <AreYouSureDialog
                  content={
                    <TranslationWrapper tKey={"Are you sure you want to delete the selected scheduled tasks?"} />
                  }
                  onOk={() => {
                    _post("/core/scheduledtasks/multipledelete", { ids: selected }).then(() => {
                      updateReloadState();
                    });
                  }}
                />
              ),
            });
          }}
          style={{ color: "lightcoral" }}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    );
  }, []);

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        <Link to={`./${row.id}/edit`}>
          <Tooltip
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
          >
            <IconButton color={"primary"} simple size={"small"}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Link>
      </TableCell>
    );
  }, []);

  const filters = useMemo(() => {
    let filters = {};
    if (searchFilter) {
      filters = searchFilter;
    }
    if (props.filters) {
      filters = { ...filters, ...props.filters };
    }
    return filters;
  }, [searchFilter, props.filters]);

  return (
    <div>
      <MainNavbar
        paginaTitel={<TranslationWrapper tDefault={"Scheduled Tasks"} tKey={"scheduledTasks.table.title"} />}
      />

      {props.vestiging_id > 0 ? (
        <GridContainer>
          <GridItem xs={12}>
            <AuthenticationWrapper
              child={
                <Link to={"./create"}>
                  <Button color={"success"}>
                    <Add />{" "}
                    <TranslationWrapper
                      tDefault={"Create new scheduled task"}
                      tKey={"scheduledTasks.createNewScheduledTask"}
                    />
                  </Button>
                </Link>
              }
              permissionKey={"scheduledTasks.create"}
            />
          </GridItem>
        </GridContainer>
      ) : null}
      <VestigingenFilter />
      {textField}
      <GridLegacy container spacing={1}>
        <GridLegacy item xs={12}>
          <JamezzTableV2
            checkboxSelection={true}
            delete={"scheduledTasks.delete"}
            dense={true}
            endPoint={endPoint}
            filters={filters}
            headerIcon={<FreeBreakfast />}
            reloadState={reloadState}
            renderCellsForRow={renderRowCells}
            renderHeaderCells={renderHeaderCells}
            renderRowActions={renderRowActions}
            renderSelectionActions={renderSelectionActions}
            tableTitle={<TranslationWrapper tDefault={"Scheduled Tasks"} tKey={"scheduledTasks.table.title"} />}
          />
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);

  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};
export default connect(mapStateToProps)(ScheduledTasks);
